// Von Server und Web-App gemeinsam genutzt, damit eine Push-Nachricht und die
// Anzeige in der App nie unterschiedliche Zahlen zeigen.

/**
 * "320 m" / "2,5 km"
 * @param {number} meters
 * @returns {string}
 */
export function formatDistance(meters) {
  if (!Number.isFinite(meters)) return '-';
  if (meters < 1000) return `${Math.round(meters / 10) * 10} m`;
  return `${(meters / 1000).toFixed(1).replace('.', ',')} km`;
}

/**
 * "unter 1 Minute" / "7 Minuten" / "1 h 5 min"
 * @param {number} seconds
 * @returns {string}
 */
export function formatDuration(seconds) {
  if (!Number.isFinite(seconds)) return '-';
  if (seconds < 45) return 'unter 1 Minute';
  const minutes = Math.round(seconds / 60);
  if (minutes === 1) return '1 Minute';
  if (minutes < 60) return `${minutes} Minuten`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours} h ${rest} min` : `${hours} h`;
}

/**
 * Kompakte Minutenangabe für die große Zahl auf dem Wartebildschirm.
 * @param {number} seconds
 * @returns {string}
 */
export function formatEtaShort(seconds) {
  if (!Number.isFinite(seconds)) return '-';
  if (seconds < 45) return 'gleich';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
}

/**
 * "vor 3 Minuten" für das Alter einer Position.
 * @param {number} seconds
 * @returns {string}
 */
export function formatAge(seconds) {
  if (!Number.isFinite(seconds)) return '-';
  if (seconds < 20) return 'gerade eben';
  if (seconds < 90) return 'vor weniger als einer Minute';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `vor ${minutes} Minuten`;
  const hours = Math.floor(minutes / 60);
  return `vor ${hours} ${hours === 1 ? 'Stunde' : 'Stunden'}`;
}
